import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import {
  Button,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
  FormText,
  Label,
} from 'reactstrap'

const CategoryForm = ({
  onSubmit,
  loading,
  register,
  errors,
  readOnly,
}) => (
  <Form onSubmit={onSubmit} noValidate autoComplete="off">
    <Input name="id" type="hidden" innerRef={register} />
    <div className="pl-lg-4">
      <Row>
        <Col lg="6">
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="input-categoryname"
            >
              Nombre de la Categoría
            </Label>
            <Input
              className="form-control-alternative"
              disabled={readOnly}
              id="input-categoryname"
              autoComplete="off"
              placeholder="Nombre de la Categoría"
              type="text"
              name="name"
              innerRef={register({ required: true })}
            />
            {errors.name && errors.name.type === 'required' && (
              <FormText color="primary">
                Ingrese un nombre de categoría
              </FormText>
            )}
          </FormGroup>
        </Col>
        <Col lg="6">
          <FormGroup>
            <Label
              className="form-control-label"
              htmlFor="input-description"
            >
              Código
            </Label>
            <Input
              className="form-control-alternative"
              id="input-description"
              disabled={readOnly}
              autoComplete="off"
              placeholder="Código"
              type="textarea"
              name="description"
              innerRef={
                register({ required: true })
              }
            />
            {errors.description && errors.description.type === 'required' && (
              <FormText color="primary">
                Ingrese el código de la categoría
              </FormText>
            )}
          </FormGroup>
        </Col>
      </Row>
    </div>
    {!readOnly && (
      <>
        <hr className="my-4" />
        <Button disabled={loading} color="primary">Guardar</Button>
      </>
    )}
  </Form>
)

CategoryForm.propTypes = {
  loading: PropTypes.bool,
  readOnly: PropTypes.bool,
  onSubmit: PropTypes.func,
  register: PropTypes.func,
  errors: PropTypes.shape({
    name: PropTypes.shape({
      type: PropTypes.string
    })
  }),
}

CategoryForm.defaultProps = {
  loading: false,
  readOnly: false,
  onSubmit: noop,
  errors: {}
}

export default CategoryForm
